var _g, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShadows({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 532,
    height: 866,
    viewBox: "0 0 532 866",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3803_9419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.642 857.383L8.59912 628.341H237.642V857.383Z",
    fill: "url(#paint0_linear_3803_9419)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3803_9419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523.945 237.441L294.902 8.39874V237.441H523.945Z",
    fill: "url(#paint1_linear_3803_9419)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3803_9419",
    x: 0.964367,
    y: 620.706,
    width: 244.312,
    height: 244.312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.81738,
    result: "effect1_foregroundBlur_3803_9419"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3803_9419",
    x: 287.268,
    y: 0.763988,
    width: 244.312,
    height: 244.312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.81738,
    result: "effect1_foregroundBlur_3803_9419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3803_9419",
    x1: 18.3523,
    y1: 590.609,
    x2: 138.851,
    y2: 734.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3803_9419",
    x1: 299.002,
    y1: 14.085,
    x2: 421.103,
    y2: 136.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadows);
export default __webpack_public_path__ + "static/media/shadows.38e762d443a75b9ddc2eac584652581f.svg";
export { ForwardRef as ReactComponent };